module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('h2', [_vm._v("Contents")]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "href": "#/supernaturalepub#_idParaDest-1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/supernaturalepub1#_idParaDest-2"
    }
  }, [_vm._v("The Dingus")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/supernaturalepub2#_idParaDest-3"
    }
  }, [_vm._v("The Getaway")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub3#_idParaDest-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mortal Bait")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub4#_idParaDest-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Little Shit")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub5#_idParaDest-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ditch Witch")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub6#_idParaDest-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Triangle")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub7#_idParaDest-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Carrion Gods in their Heaven")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub8#_idParaDest-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Romance")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub9#_idParaDest-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dead Sister")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub10#_idParaDest-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comfortable in Her Skin")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub11#_idParaDest-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("But For Scars")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub12#_idParaDest-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Absent Eye")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub13#_idParaDest-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Maltese Unicorn")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub14#_idParaDest-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dreamer of the Day")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub15#_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Paris, in the Mouth of Kronos")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/supernaturalepub16#_idParaDest-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks"
    }
  }, [_c('h2', [_vm._v("Landmarks")]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    attrs: {
      "epub:type": "cover",
      "href": "#/cover"
    }
  }, [_vm._v("Cover")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 72
// module chunks = 0